<template>
  <!-- breadcrumb-bar-->
  <div class="breadcrumb-bar">
    <div class="container">
      <div class="row align-items-center text-center">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title text-white">{{ title }}</h2>
          <nav aria-label="breadcrumb" class="page-breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/index-5" class="text-white">الرئيسية</router-link>
              </li>
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" class="text-white">{{ text }}</a>
              </li>
              <li class="breadcrumb-item active text-white" aria-current="page">
                {{ text1 }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- / breadcrumb-bar -->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.breadcrumb-bar {
  background: transparent !important;
}

</style>
